import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "disabled", "htmlFor", "id", "required", "visuallyHidden", "sx", "as"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React__default from 'react';
import VisuallyHidden from '../../_VisuallyHidden.js';
import Box from '../../Box/Box.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var InputLabel = function InputLabel(_ref) {
  var children = _ref.children,
    disabled = _ref.disabled,
    htmlFor = _ref.htmlFor,
    id = _ref.id,
    required = _ref.required,
    visuallyHidden = _ref.visuallyHidden,
    sx = _ref.sx,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'label' : _ref$as,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(VisuallyHidden, _extends({
    isVisible: !visuallyHidden,
    as: as /* This assertion is clearly wrong, but it's the only way TS will allow the htmlFor prop to be possibly defined */,

    htmlFor: htmlFor,
    id: id,
    sx: _objectSpread({
      fontWeight: 'bold',
      fontSize: 1,
      display: 'block',
      color: disabled ? 'fg.muted' : 'fg.default',
      cursor: disabled ? 'not-allowed' : 'pointer',
      alignSelf: 'flex-start'
    }, sx)
  }, props), required ? /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    as: "span"
  }, /*#__PURE__*/React__default.createElement(Box, {
    mr: 1
  }, children), /*#__PURE__*/React__default.createElement("span", null, "*")) : children);
};
InputLabel.displayName = "InputLabel";
var InputLabel$1 = InputLabel;
export { InputLabel$1 as default };